module.exports = __webpack_public_path__ + "assets/img/mecha-47f8f66a.png";